import OperatorActionTypes from './types';

const initialState = {
  activeScreen: 2,
  isYourVehicle: 'yes',
  vehicleBodyType: '',

  rcFrontResourceKey: '',
  rcBackResourceKey: '',

  vehicleTyre: [],

  vehicleSelectedTyre: '',
  vehicleSelectedSize: '',
  vehicleSelectedHeight: '',
  vehicleSelectedTun: '',
  vehicleSelectecNumber: {},
  vehicleHeight: [],

  // vehicleRcFront:'',
  // vehicleRcBack:'',

  RcImageFrontView: '',
  RcImagebackView: '',

  vehicleSelectedBody: '',

  vehicleListing: [],

  updateVehicleSuccess: '',

  // OPERATOR_GET_UPLOADED_BACK_IMAGES_SUCCESS
  operatorDocList: [],

  operatorAdharFront: '',
  operatorAdharBack: '',

  operatorFrontResourceKey: '',
  operatorBackResourceKey: '',
  isFetchingLoadsList: false,
  vehicleNoDataFound: false,
  isFetchTyreList: false,
  tyreListNoDataFound: false,
  isOperatorDocSubmit: false,
  isDocSubmit: false,
  isOperatorDocList: false,
  documents: {},
  vehicleInputWidget: {},
};

const operatorReducer = (state: any = initialState, action: { type: string; payload: any }) => {
  switch (action.type) {
    case OperatorActionTypes.FETCH_OPERATOR_ACTIVE_SCREEN:
      return {
        ...state,
        activeScreen: action.payload,
      };
    case OperatorActionTypes.FETCH_OPERATOR_IS_YOUR_VEHICLE:
      return {
        ...state,
        isYourVehicle: action.payload,
      };
    case OperatorActionTypes.FETCH_OPERATOR_VEHICLE_BODYTYPE:
      return {
        ...state,
        vehicleBodyType: action.payload,
      };

    case OperatorActionTypes.GET_RESOURCE_KEY_RC_FRONT:
      return {
        ...state,
        rcFrontResourceKey: action.payload,
      };

    case OperatorActionTypes.GET_RESOURCE_KEY_RC_BACK:
      return {
        ...state,
        rcBackResourceKey: action.payload,
      };

    case OperatorActionTypes.FETCH_OPERATOR_VEHICLE_TYRE_LISTING_START:
      return {
        ...state,
        tyreListNoDataFound: false,
        isFetchTyreList: true,
        vehicleTyre: [],
      };

    case OperatorActionTypes.FETCH_OPERATOR_VEHICLE_TYRE_LISTING_SUCCESS:
      return {
        ...state,
        tyreListNoDataFound: false,
        isFetchTyreList: false,
        vehicleTyre: action.payload,
      };

    case OperatorActionTypes.FETCH_OPERATOR_VEHICLE_TYRE_LISTING_FAILURE:
      return {
        ...state,
        tyreListNoDataFound: true,
        isFetchTyreList: false,
        vehicleTyre: [],
      };

    case OperatorActionTypes.UPDATE_VEHICLE_SUCCESS:
      return {
        ...state,
        updateVehicleSuccess: action.payload,
      };
    case OperatorActionTypes.POST_VEHICLE_DATA_UPDATE_START_V2:
      return {
        ...state,
      };
    case OperatorActionTypes.POST_VEHICLE_DATA_UPDATE_SUCCESS_V2:
      const { index, vehicleInputWidget } = action.payload;
      const addVehicleInputWidget = (vehicleListing: any, id: any) => {
        const currentVehicle = vehicleListing.filter((_: any, index: number) => index === id);
        currentVehicle[0].vehicleInputWidget = vehicleInputWidget;
        vehicleListing[id] = currentVehicle[0];
        return vehicleListing;
      };
      return {
        ...state,
        vehicleListing: [...addVehicleInputWidget(state.vehicleListing, index)],
      };
    // case OperatorActionTypes.POST_UPLOAD_DOC_START:
    // return {
    //   ...state,
    //   vehicleRcFront: {},
    // };

    // case OperatorActionTypes.POST_UPLOAD_DOC_SUCCESS:
    // return {
    //   ...state,
    //   vehicleRcFront: action.payload,
    // };
    case OperatorActionTypes.UPLOAD_DOCUMENT_SUCCESS:
      const { id, data } = action.payload;
      return {
        ...state,
        documents: {
          ...state.documents,
          [id]: data,
        },
      };
    case OperatorActionTypes.UPLOAD_DOCUMENT_FAILURE:
      return {
        ...state,
      };
    case OperatorActionTypes.CLEAR_DOCUMENTS:
      return {
        ...state,
        documents: {},
      };
    case OperatorActionTypes.CLEAR_DOCUMENT:
      const { doc } = action.payload;
      return {
        ...state,
        documents: {
          ...state.documents,
          [doc]: {},
        },
      };
    case OperatorActionTypes.GET_UPLOADED_IMAGES_START:
      return {
        ...state,
        // isDocSubmit:true,
        RcImageFrontView: '',
      };
    case OperatorActionTypes.GET_UPLOADED_IMAGES_SUCCESS:
      return {
        ...state,
        // isDocSubmit:false,
        RcImageFrontView: action.payload,
      };

    case OperatorActionTypes.GET_UPLOADED_IMAGES_FAILURE:
      return {
        ...state,
        // isDocSubmit:false,
        RcImageFrontView: '',
      };

    case OperatorActionTypes.GET_UPLOADED_RC_BACK_IMAGES_START:
      return {
        ...state,
        RcImagebackView: '',
      };
    case OperatorActionTypes.GET_UPLOADED_RC_BACK_IMAGES_SUCCESS:
      return {
        ...state,
        RcImagebackView: action.payload,
      };

    case OperatorActionTypes.GET_UPLOADED_RC_BACK_IMAGES_FAILURE:
      return {
        ...state,
        RcImagebackView: '',
      };

    // case OperatorActionTypes.FETCH_OPERATOR_VEHICLE_TUN:
    // return {
    //   ...state,
    //   vehicleTun: action.payload,
    // };
    // case OperatorActionTypes.FETCH_OPERATOR_VEHICLE_SIZE:

    // return {
    //   ...state,
    //   vehcileSize: action.payload,
    // };
    // case OperatorActionTypes.FETCH_OPERATOR_VEHICLE_FRONT_RC:
    // return {
    //   ...state,
    //   vehicleRcFront: action.payload,
    // };

    // case OperatorActionTypes.FETCH_OPERATOR_VEHICLE_BACK_RC:
    // return {
    //   ...state,
    //   vehicleRcBack: action.payload,
    // };
    case OperatorActionTypes.FETCH_OPERATOR_VEHICLE_SELECTED_NUMBER:
      return {
        ...state,
        vehicleSelectecNumber: action.payload,
      };

    case OperatorActionTypes.FETCH_OPERATOR_VEHICLE_SELECTED_SIZE:
      return {
        ...state,
        vehicleSelectedSize: action.payload,
      };
    case OperatorActionTypes.FETCH_OPERATOR_VEHICLE_SELECTED_TYRE:
      return {
        ...state,
        vehicleSelectedTyre: action.payload,
      };
    case OperatorActionTypes.FETCH_OPERATOR_VEHICLE_SELECTED_TUN:
      return {
        ...state,
        vehicleSelectedTun: action.payload,
      };
    case OperatorActionTypes.FETCH_OPERATOR_VEHICLE_SELECTED_HEIGHT:
      return {
        ...state,
        vehicleSelectedHeight: action.payload,
      };
    case OperatorActionTypes.FETCH_OPERATOR_VEHICLE_SELECTED_HEIGHT:
      return {
        ...state,
        vehicleSelectedHeight: action.payload,
      };
    case OperatorActionTypes.FETCH_OPERATOR_VEHICLE_SELECTED_BODY:
      return {
        ...state,
        vehicleSelectedBody: action.payload,
      };

    case OperatorActionTypes.FETCH_OPERATOR_VEHICLE_LISTING_START:
      return {
        ...state,
        isFetchingLoadsList: 'true',
        vehicleListing: [],
      };

    case OperatorActionTypes.FETCH_OPERATOR_LISTING_SUCCESS:
      return {
        ...state,
        vehicleNoDataFound: false,
        isFetchingLoadsList: false,
        vehicleListing: action.payload,
      };
    case OperatorActionTypes.ALTER_OPERATOR_LISTING:
      return {
        ...state,
        vehicleListing: state.vehicleListing.map((v: any) => {
          if (v.vehicleId === action.payload.vehicleId) {
            return {
              ...v,
              heading: action.payload.data.heading,
              description: action.payload.data.description,
              vehicleInputWidget: action.payload.data.vehicleInputWidget,
              statusHi: action.payload.data.statusHi,
            };
          }
          return v;
        }),
      };

    case OperatorActionTypes.FETCH_OPERATOR_VEHICLE_LISTING_FAILURE:
      return {
        ...state,
        isFetchingLoadsList: false,
        vehicleNoDataFound: true,
        vehicleListing: [
          {
            vehicleId: 0,
            bodyType: 'string',
            number: 'string',
            tyreCount: 0,
            tonnage: 0,
            sizeInFeet: 0,
            height: 0,
            ownership: 'SELF',
            ownerName: 'string',
            status: 'VERIFIED',
            docInfoStatus: true,
            vehicleInfoStatus: true,
            rcFrontResourceKey: 'string',
            rcBackResourceKey: 'string',
            vehDecResourceKey: 'string',
            vehicleType: 'string',
            vehicleTypeHindi: 'string',
            sortScore: 0,
          },
        ],
      };

    // operator reducer start from here OPERATOR_DOC_LIST_FAILURE

    case OperatorActionTypes.OPERATOR_DOC_LIST_START:
      return {
        ...state,
        isOperatorDocList: true,
        operatorDocList: [],
      };

    case OperatorActionTypes.OPERATOR_DOC_LIST_SUCCESS:
      return {
        ...state,
        isOperatorDocList: false,

        operatorDocList: action.payload,
      };

    case OperatorActionTypes.OPERATOR_DOC_LIST_FAILURE:
      return {
        ...state,
        isOperatorDocList: false,
        operatorDocList: [],
      };

    // OPERATOR_GET_UPLOADED_BACK_IMAGES_SUCCESS
    case OperatorActionTypes.OPERATOR_GET_UPLOADED_IMAGES_START:
      return {
        ...state,
        operatorAdharFront: '',
      };

    case OperatorActionTypes.OPERATOR_GET_UPLOADED_IMAGES_SUCCESS:
      return {
        ...state,
        operatorAdharFront: action.payload,
      };

    case OperatorActionTypes.OPERATOR_GET_UPLOADED_IMAGES_FAILURE:
      return {
        ...state,
        operatorAdharFront: '',
      };

    case OperatorActionTypes.OPERATOR_GET_UPLOADED_BACK_IMAGES_START:
      return {
        ...state,
        operatorAdharBack: '',
      };

    case OperatorActionTypes.OPERATOR_GET_UPLOADED_BACK_IMAGES_SUCCESS:
      return {
        ...state,
        operatorAdharBack: action.payload,
      };

    case OperatorActionTypes.OPERATOR_GET_UPLOADED_BACK_IMAGES_FAILURE:
      return {
        ...state,
        operatorAdharBack: '',
      };

    // GET_RESOURCE_KEY_AAADHAR_FRONT

    case OperatorActionTypes.GET_RESOURCE_KEY_AAADHAR_FRONT:
      return {
        ...state,
        operatorFrontResourceKey: action.payload,
      };

    case OperatorActionTypes.GET_RESOURCE_KEY_AAADHAR_BACK:
      return {
        ...state,
        operatorBackResourceKey: action.payload,
      };

    case OperatorActionTypes.POST_OPERATOR_DATA_UPDATE_START:
      return {
        ...state,
        isOperatorDocSubmit: false,
      };
    case OperatorActionTypes.POST_OPERATOR_DATA_UPDATE_SUCCESS:
      return {
        ...state,
        isOperatorDocSubmit: true,
      };

    case OperatorActionTypes.OPERATOR_POST_UPLOAD_DOC_START:
      return {
        ...state,
        isDocSubmit: true,
      };

    case OperatorActionTypes.OPERATOR_POST_UPLOAD_DOC_SUCCESS:
      return {
        ...state,
        isDocSubmit: false,
      };
    case OperatorActionTypes.FETCH_GPS_IMAGE_URLS:
      return {
        ...state,
        imageUrlData: [],
      };
    case OperatorActionTypes.FETCH_GPS_IMAGE_URLS_SUCCESS:
      return {
        ...state,
        imageUrlData: action.payload,
      };

    case OperatorActionTypes.FETCH_GPS_IMAGE_URLS_FAILURE:
      return {
        ...state,
        imageUrlData: [],
      };

    case OperatorActionTypes.FETCH_GPS_VARIANT_SUCCESS:
      return {
        ...state,
        gpsVariant: action.payload,
      };

    case OperatorActionTypes.FETCH_GPS_VARIANT_FAILURE:
      return {
        ...state,
        gpsVariant: [],
      };
    case OperatorActionTypes.FETCH_VEH_REQ_DATA_SUCCESS:
      const vId = action.payload.vId;
      const vehInputWidget = action.payload.data.vehicleInputWidget;
      return {
        ...state,
        vehicleInputWidget: {
          [vId]: vehInputWidget,
        },
      };
    case OperatorActionTypes.SET_VEHICLE_FORM_DATA:
      const { vehicleId } = action.payload;
      return {
        ...state,
        vehicleInputWidget: {
          [vehicleId]: action.payload.vehicleInputWidget,
        },
      };
    default:
      return state;
  }
};

export default operatorReducer;
